import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { BookOpen, Trash2 } from "lucide-react";

export default function Shelves() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/shelf").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const remove = async (bookId) => {
    try { await api.delete(`/shelf/${bookId}`); toast.success("Removed"); load(); }
    catch { toast.error("Could not remove"); }
  };

  return (
    <div className="space-y-6" data-testid="shelves-page">
      <div>
        <div className="chip mb-2">My shelf</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Saved books, ready to open.</h1>
        <p className="text-slate-600 mt-1">Everything you tap "save" on lives here.</p>
      </div>

      {items.length === 0 && (
        <div className="p-8 rounded-3xl bg-white border border-slate-200 text-center">
          <BookOpen className="mx-auto text-slate-400" size={32} />
          <div className="mt-2 text-slate-700">Your shelf is empty.</div>
          <Link to="/books" className="mt-3 inline-block text-teal-700 font-semibold">Browse books →</Link>
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="shelf-grid">
        {items.map((it) => (
          <div key={it.book_id} data-testid={`shelf-item-${it.book_id}`}
            className="p-4 rounded-2xl bg-white border border-slate-200 flex gap-3">
            <div className="w-14 h-20 shrink-0 rounded-md bg-slate-100 overflow-hidden">
              {it.cover_url && <img src={it.cover_url} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900 line-clamp-2">{it.title}</div>
              {it.author && <div className="text-xs text-slate-500 mt-0.5">{it.author}</div>}
              <div className="mt-2 flex gap-2 text-xs">
                <Link to={`/books/${it.book_id}`} data-testid={`shelf-read-${it.book_id}`}
                  className="px-3 py-1.5 rounded-full bg-teal-700 hover:bg-teal-800 text-white font-semibold">Read</Link>
                <button data-testid={`shelf-remove-${it.book_id}`} onClick={() => remove(it.book_id)}
                  className="px-3 py-1.5 rounded-full border border-slate-200 text-slate-500 hover:text-red-600 inline-flex items-center gap-1"><Trash2 size={10} /> Remove</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
